import { Box, Link, Stack, Typography } from "@mui/material";
import { useLanguage } from "../i18n/LanguageContext";
import { COLORS } from "../theme";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <Box sx={{ maxWidth: 1200, width: "100%", mt: 5, pt: 2, borderTop: `1px solid ${COLORS.line}` }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 0.5, sm: 2 }} alignItems={{ sm: "center" }}>
        <Typography variant="caption" color="text.secondary">
          {t("footer.legal")}:
        </Typography>
        <Link href="/legal/acuerdo-confidencialidad-residentes.pdf" target="_blank" rel="noopener" variant="caption">
          {t("footer.residentsAgreement")}
        </Link>
        <Link href="/legal/acuerdo-confidencialidad-visitantes.pdf" target="_blank" rel="noopener" variant="caption">
          {t("footer.visitorsAgreement")}
        </Link>
      </Stack>
    </Box>
  );
}
